import styled from 'styled-components';
import colours from 'theme/atoms/colours';
import * as Text from 'theme/components/Text.style';

export const Card = styled('div')`
  background: ${colours.neutral[200]};
  border-radius: 30px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 15px;
  width: 100%;
`;

export const Action = styled('div')`
  margin-top: 5px;
`;

export const Subtitle = styled(Text.P2)`
  color: ${colours.neutral[600]};
  font-weight: 500;
`;
